import {
  APP_MULTI_PARTNER,
  APP_PARTNER_FULL_NAME,
  APP_PARTNER_ID,
  APP_PARTNER_NAME,
  CHOSEN_PARTNER_FULL_NAME,
  CHOSEN_PARTNER_ID,
  CHOSEN_PARTNER_NAME,
} from '../../configs/app.config';
import { isClient } from '../next/next.util';

import type { TAvailableValuesType } from '../../types/components/components.type';

export const isMultiPartner = (): boolean => APP_MULTI_PARTNER;

export const getPartnerName = (): string => {
  if (isMultiPartner() && isClient()) {
    return sessionStorage.getItem(CHOSEN_PARTNER_NAME) ?? APP_PARTNER_NAME;
  }
  return APP_PARTNER_NAME;
};

export const getPartnerFullName = (): string => {
  if (isMultiPartner() && isClient()) {
    return sessionStorage.getItem(CHOSEN_PARTNER_FULL_NAME) ?? APP_PARTNER_FULL_NAME;
  }
  return APP_PARTNER_FULL_NAME;
};

export const getPartnerId = (): string => {
  if (isMultiPartner() && isClient()) {
    return sessionStorage.getItem(CHOSEN_PARTNER_ID) ?? (APP_PARTNER_ID.split(',').at(0) || '');
  }
  return APP_PARTNER_ID;
};

export const availablePartnerFullNames = (): TAvailableValuesType => {
  if (isMultiPartner()) {
    return APP_PARTNER_ID.split(',').map((partnerName, index) => {
      const fullName = APP_PARTNER_FULL_NAME.split(',')[index]?.trim();
      return {
        label: fullName ?? partnerName.trim(),
        value: partnerName.trim(),
      };
    });
  }

  return [];
};

export const checkPartnerName = (): string => {
  const partnerName = getPartnerName().toLowerCase();
  switch (partnerName) {
    case 'gtfi':
    case 'gbpl':
    case 'gtu,gztu,gpte,gf':
      return 'generali';
    case 'ump':
      return 'universalmusic';
    case 'mps':
      return 'muzeumpilsudskiego';
    default: {
      return 'default';
    }
  }
};
